import React from "react";

import { Icon } from "@iconify/react/dist/iconify.js";

export const DisplayNotAvailable: React.FC = () => {
  return (
    <div className="notAvailable_container">
      <Icon icon="fe:app-menu" color="#c4c4c4" height={50} />
      <h5>Display is not available</h5>
      <p>
        csv, xls and xlsx file displays will be <br /> supported in the future
      </p>
    </div>
  );
};
